const Support = () => {
  const goHome = () => {
    window.history.pushState(null, "", "/");
    window.location.reload();
  };

  return (
    <div className="legal-container">
      <div className="legal-content">
        <button onClick={goHome} className="back-button">
          ← Retour à l'accueil
        </button>
        <h1>Support Dispo</h1>
        <p className="description">
          Une question, un bug, une suggestion ? On est là pour t'aider.
        </p>

        <section className="info-section">
          <h2>Nous contacter</h2>
          <ul>
            <li>
              <strong>Email&nbsp;:</strong>{" "}
              <a href="mailto:contact@getdispo.com">contact@getdispo.com</a>
            </li>
            <li>
              Réponse sous <strong>48&nbsp;heures ouvrées</strong>.
            </li>
          </ul>
        </section>

        <section className="info-section">
          <h2>FAQ rapide</h2>
          <ul>
            <li>
              <strong>Mot de passe oublié&nbsp;?</strong> Utilise «&nbsp;Mot
              de passe oublié&nbsp;» sur l'écran de connexion (avec ton email
              de récupération), ou connecte-toi avec Apple ou Google&nbsp;:
              pas de mot de passe à retenir.
            </li>
            <li>
              <strong>Notifications non reçues&nbsp;?</strong> Vérifie les
              autorisations dans Réglages &gt; Notifications &gt; Dispo.
            </li>
            <li>
              <strong>Supprimer mon compte&nbsp;?</strong> Utilise la page{" "}
              <a href="/askdelete">Demande de suppression</a>.
            </li>
            <li>
              <strong>Signaler un contenu&nbsp;?</strong> Écris-nous à
              contact@getdispo.com en précisant le pseudo concerné.
            </li>
          </ul>
        </section>

        <section className="info-section">
          <h2>Liens utiles</h2>
          <ul>
            <li>
              <a href="/privacy">Politique de confidentialité</a>
            </li>
            <li>
              <a href="/terms">Conditions d'utilisation</a>
            </li>
            <li>
              <a href="/askdelete">Demande de suppression de compte</a>
            </li>
          </ul>
        </section>
      </div>

      <style jsx>{`
        .legal-container {
          min-height: 100vh;
          background: linear-gradient(
            135deg,
            #061220 0%,
            #0a1929 50%,
            #102a43 100%
          );
          padding: 40px 20px;
          color: #f0f4f8;
          font-family: "Poppins", system-ui, sans-serif;
        }

        .legal-content {
          max-width: 600px;
          margin: 0 auto;
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 40px;
          border: 1px solid rgba(56, 189, 248, 0.15);
        }

        .back-button {
          background: rgba(56, 189, 248, 0.1);
          border: 1px solid rgba(56, 189, 248, 0.3);
          color: #38bdf8;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
          margin-bottom: 20px;
          transition: all 0.3s ease;
          font-family: "Poppins", system-ui, sans-serif;
        }

        .back-button:hover {
          background: rgba(56, 189, 248, 0.2);
          transform: translateY(-2px);
        }

        h1 {
          font-size: 2rem;
          margin-bottom: 10px;
          text-align: center;
          font-weight: 600;
          background: linear-gradient(135deg, #38bdf8 0%, #7dd3fc 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .description {
          text-align: center;
          opacity: 0.8;
          margin-bottom: 30px;
          color: #9fb3c8;
          line-height: 1.6;
        }

        .info-section {
          margin-top: 40px;
          padding-top: 30px;
          border-top: 1px solid rgba(56, 189, 248, 0.15);
        }

        .info-section h2 {
          font-size: 1.2rem;
          margin-bottom: 15px;
          color: #38bdf8;
        }

        .info-section ul {
          margin: 0;
          padding-left: 20px;
        }

        .info-section li {
          margin-bottom: 10px;
          line-height: 1.6;
          color: #bcccdc;
          font-size: 15px;
        }

        a {
          color: #7dd3fc;
          text-decoration: underline;
        }

        a:hover {
          color: #bae6fd;
        }

        @media (max-width: 768px) {
          .legal-content {
            padding: 20px;
            margin: 0 10px;
          }

          h1 {
            font-size: 1.6rem;
          }
        }
      `}</style>
    </div>
  );
};

export default Support;
